import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { qk } from '../../api/queries';
import { Loading } from '../../components/ui';

/** OAuth callback landing (the backend redirects here after setting the session). */
export function OAuthCompletePage() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  useEffect(() => {
    void qc
      .invalidateQueries({ queryKey: qk.session })
      .then(() => navigate('/', { replace: true }));
  }, [qc, navigate]);
  return <Loading />;
}
